import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { CalendarDataCarrierService } from '../../services/calendar-datacarrier-service/calendar-data-carrier.service';
import { ScheduleOptionsCacheService } from '../../services/schedule-options-cache-service/schedule-options-cache.service';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { CalendarViewCache } from '../../models/calendar-view-cache';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-mobile-calendar',
  templateUrl: './mobile-calendar.component.html',
  styleUrls: ['./mobile-calendar.component.scss']
})
export class MobileCalendarComponent extends ComponentBase implements OnInit {
  constructor(private pageHeadingService: PageHeadingService
    , private routingService: RoutingService
    , private calendarDataCarrierSvc: CalendarDataCarrierService
    , private scheduleOptionsCacheService: ScheduleOptionsCacheService
    , private datePipe: DatePipe
  ) {
    super();
    this.currentDate.setDate(1);
  }

  currentDate: Date = new Date();
  currentMonth: string;
  todaysdate: string = new Date().toISOString().split('T')[0];
  showHolidays: boolean = true;
  showExams: boolean = true;
  showEvents: boolean = true;
  option: number = 1;
  cachedCalendarView: CalendarViewCache;
  showOptions: boolean;

  ngOnInit() {
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Calendar"));
    let sub = this.calendarDataCarrierSvc.subscribeCalendarView()
      .subscribe(res => {
        setTimeout(() => {
          this.currentMonth = res.month_title;
        }, 0);
        this.cachedCalendarView = res;
        this.currentDate = res.current_date;
        this.option = res.widget;
      });
    this.addSubscription(sub);
    this.scheduleOptionsCacheService.changeOptions(this.showHolidays, this.showEvents, this.showExams);
  }

  todayClicked() {
    this.calendarDataCarrierSvc.todayCliceked();
  }

  holidayChecked() {
    this.showHolidays = !this.showHolidays;
    this.changeOptions();
  }

  eventsChecked() {
    this.showEvents = !this.showEvents;
    this.changeOptions();
  }

  examsChecked() {
    this.showExams = !this.showExams;
    this.changeOptions();
  }

  changeOptions() {
    this.scheduleOptionsCacheService.changeOptions(this.showHolidays, this.showEvents, this.showExams);
  }

  optionClicked() {
    this.showOptions = true;
  }

  ClickedOutsideDropdown() {
    this.showOptions = false;
  }

  redirectToMonth() {
    if (!this.cachedCalendarView.current_date) {
      this.cachedCalendarView.current_date = new Date();
    }
    let route = new PrifactRoute();
    route.replace_url = true;
    this.cachedCalendarView.current_date.setDate(1);
    route.primary_command = ['pages', 'calendar', 'month', this.cachedCalendarView.current_date.toISOString().split('T')[0]];
    this.routingService.navigate(route);
  }

  redirectToschedule() {
    if (!this.cachedCalendarView.current_date) {
      this.cachedCalendarView.current_date = new Date();
    }
    let route = new PrifactRoute();
    route.replace_url = true;
    this.cachedCalendarView.current_date.setDate(1);
    route.primary_command = ['pages', 'calendar', 'schedule'];
    this.routingService.navigate(route);
  }

  subMenuClicked(item: number) {
    if (item == 1) {
      this.showHolidays = true;
      this.showEvents = false;
      this.showExams = false;
      this.changeOptions();
    }
    else if (item == 2) {
      this.showHolidays = false;
      this.showEvents = true;
      this.showExams = false;
      this.changeOptions();
    }
    else if (item == 3) {
      this.showHolidays = false;
      this.showEvents = false;
      this.showExams = true;
      this.changeOptions();
    }
    this.redirectToschedule();
  }

  isCurrentMonth() : boolean{
     let today = new Date(); 
    let month = this.datePipe.transform(today, "MMMM yyyy");
    if(month == this.currentMonth){
      return true
    }
    return false;
  }
}